<template>
  <BaseModal
    content-class="max-w-6xl flex flex-1 !bg-capino-light"
    skin-padding="p-2 md:p-8"
    @close="handleClose"
  >
    <TheExercises
      class="-mt-8"
      :section-slug="sectionSlug"
      :topic-slug="topicSlug"
      is-demo
      :is-back-button="false"
      @close-demo="handleClose"
    />

    <TheConfetti v-if="ui.confetti.isVisible" />
  </BaseModal>
</template>

<script>
import { mapState } from 'vuex'

import BaseModal from '@/components/Base/BaseModal.vue'
import TheExercises from '@/components/Hub/Exercises/TheExercises.vue'
import TheConfetti from '@/components/Confetti/TheConfetti.vue'

export default {
  name: 'DemoAllSectionModal',

  components: { BaseModal, TheExercises, TheConfetti },

  props: {
    sectionSlug: { type: String, required: true },
    topicSlug: { type: String, required: true }
  },

  computed: {
    ...mapState('ui', ['ui'])
  },

  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>
